import http from "../../http-common";
export default class HubspotCreateUser  {
  postUserCreate(userInfo: {email: string, firstName: string, lastName: string}) {
    let url = `/hubspot/create-user`;

    return http.post(url, userInfo);
  }
}